/* eslint dom-in-jsx/no-document-calls: 0 */

import ReactDOM from 'react-dom';
import React from 'react';

export default class Portal extends React.Component {
  constructor(props) {
    super(props);

    this.defaultNode = undefined;
  }

  componentDidMount() {
    if (this.props.node || this.defaultNode) {
      return;
    }

    this.defaultNode = document.createElement('div');
    document.body.appendChild(this.defaultNode);
  }

  componentWillUnmount() {
    if (this.defaultNode) {
      document.body.removeChild(this.defaultNode);
    }
    this.defaultNode = undefined;
  }

  render() {
    if (!document || !document.createElement) {
      return '';
    }

    return ReactDOM.createPortal(
      this.props.children,
      this.props.node || this.defaultNode,
    );
  }
}
